import { MainButton } from 'global-styles/MainButton';
import { NormalArrowIcon } from 'assets/icons';
import { H2, H2KR, BBINDIGO } from 'global-styles';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { generateCssStyle, mediaQueryStyle } from 'styles/breakPoints';

export const AboutCheckoutProduct = () => {
  const { locale } = useRouter();
  return (
    <AboutCheckoutProductContainer>
      {locale === 'en' ? (
        <div>
          <H2>Check out the products of BLUEDOT</H2>
          <H2>for the online video service</H2>
          <H2>cost reduction.</H2>
        </div>
      ) : (
        <div>
          <H2KR>온라인 동영상 서비스</H2KR>
          <H2KR>비용절감을 위한 블루닷의</H2KR>
          <H2KR>제품들을 확인해보세요.</H2KR>
        </div>
      )}
      <Link href="/product/sr1sr2">
        <MainButton
          buttonType="default-w"
          tag="a"
          text={locale === 'en' ? 'Go to Product page' : '제품페이지 바로가기'}
          icon={<NormalArrowIcon />}
          iconPosition="right"
          injectInlineStyles={{ width: '328px', height: '56px' }}
          injectCssStyles={[
            generateCssStyle({
              height: '48px',
              'margin-top': '32px',
            }),
            mediaQueryStyle.L`
            margin-top: 56px;
            height: 56px;`,
          ]}
        />
      </Link>
    </AboutCheckoutProductContainer>
  );
};

const AboutCheckoutProductContainer = styled.section`
  background: ${BBINDIGO};
  color: #fff;
  width: 100vw;
  height: 434px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  @media screen and (max-width: 600px) {
    height: 271px;
  }
`;
